import { render, staticRenderFns } from "./CopyStakeWhitelistAddGameModal.vue?vue&type=template&id=42c2269c&scoped=true&lang=pug"
import script from "./CopyStakeWhitelistAddGameModal.vue?vue&type=script&lang=ts"
export * from "./CopyStakeWhitelistAddGameModal.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeWhitelistAddGameModal.vue?vue&type=style&index=0&id=42c2269c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c2269c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
